import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Box, Flex } from '@lightspeed/flame/Core';
import { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/flame/Modal';
import { Spinner } from '@lightspeed/flame/Spinner';
import { Text } from '@lightspeed/flame/Text';

import { StyledModal, StyledSpinnerWrapper } from './Print.style';

export const PrintModal: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState<boolean>(true);

  const handleDismiss = () => {
    setIsOpen(false);
  };

  return (
    <StyledModal data-test="print-modal" isOpen={isOpen} onRequestClose={() => handleDismiss()}>
      <ModalHeader data-test="print-modal-header">Printing in progress</ModalHeader>
      <ModalBody>
        <Flex flexDirection="column" justifyContent="center" textAlign="center">
          <Box alignSelf="center" mb={2} style={{ position: 'relative' }}>
            <img
              src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/devices/print-in-progress.svg"
              alt="Print in progress"
              data-test="print-in-progress-modal-image"
            />
            <StyledSpinnerWrapper className="spinner-wrapper">
              <Spinner size="2.625rem" color="gray-100" baseColor1="blue-500" />
            </StyledSpinnerWrapper>
          </Box>
          <Text data-test="print-modal-body">This may take a few seconds</Text>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="flex-end" alignItems="center">
          <Button data-test="print-modal-button" onClick={handleDismiss}>
            Close
          </Button>
        </Flex>
      </ModalFooter>
    </StyledModal>
  );
};
